import { render, staticRenderFns } from "./BoxHover.vue?vue&type=template&id=497e02a0&scoped=true&"
import script from "./BoxHover.vue?vue&type=script&lang=js&"
export * from "./BoxHover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497e02a0",
  null
  
)

export default component.exports